// 使用相对路径，避免浏览器在 HTTPS 页面下阻拦 HTTP 请求（混合内容）
const isHttps = typeof window !== 'undefined' ? window.location.protocol === 'https:' : false;
export const API_BASE_URL = '/api/';
export const WS_BASE_URL = `${isHttps ? 'wss' : 'ws'}://${typeof window !== 'undefined' ? window.location.host : 'localhost'}/ws`;
